import React from 'react';
import { Outlet } from 'react-router-dom';
import './OnboardingPortalLayout.scss';

const OnboardingPortalLayout = () => {
  return (
    <div className="ob-portal-layout">
      <div className="ob-portal-layout__inner">
        <Outlet />
      </div>
    </div>
  );
};

export default OnboardingPortalLayout;
